export default "__VITE_ASSET__84vh30i0__"